export const html: string = `
<ul v-if="messages" class="success-list">
    <li v-for="message in messageList()" class="success">
        {{ message }}
    </li>
</ul>
`;